export default __webpack_public_path__ + "static/media/img-0529-norway-half-face.5fc84db8.png";